import {
  FULL_SERVICE,
  GLOBAL_CATALOGS,
} from '../../types';

const initialState = {
  tabs: [],
  isLoading: false,
  value: GLOBAL_CATALOGS.Food.Announcement.List,
  announcement: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  traceability: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const foodReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_SERVICE.Food.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_SERVICE.Food.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case GLOBAL_CATALOGS.Food.Service: {
      return {
        ...state,
        tabs: action.payload
      };
    }
    case GLOBAL_CATALOGS.Food.Announcement.List: {
      return {
        ...state,
        announcement: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Food.Information.List: {
      return {
        ...state,
        traceability: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default foodReducer;
